import { Languages } from "src/common/descriptions/types";
import { CreateServiceContractDescriptions } from "./types";

const DescriptionsEnUs: CreateServiceContractDescriptions = {
    TITLE: "Create Service Contract",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Service Contract Confirmation',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Service Contract input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Contract Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Updated",
    },
    MAIN_ACTION_TITLE: "Creating Service Contract",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    EMPTY_STATES: {
        NO_CATEGORY_SELECTED: "Select a category to see the services",
        NO_SERVICES_FOR_CATEGORY: (categoryName: string) => `No services found for ${categoryName} category`,
        NO_SERVICES_IN_DETAIL: "No service selected yet",
    },
    VALIDATIONS: {
        ERROR_TITLE: "Error",
        WARNING_TITLE: "Warning",
        SERVICE_ALREADY_IN_DETAIL: (serviceName: string) => `Service ${serviceName} is already added in detail`,
        SAME_TYPE_SERVICE: "You can only add services with the same Monthly configuration",
        MISMATCH_MONTHLY_AND_SERVICE_TYPE: "Contract is setted as Monthly and the selected service is not a monthly one",
    },
    MONTHLY_SYMBOL: "M",
    OPTIONS: {
        ADD_PAYMENT: "Add payment",
        EDIT_PAYMENT: "Edit payment",
        CANCEL_INPUT: "Cancel input",
        ADD_CUSTOMER: "Add Customer",
        INACTIVATE_CONTRACT: "Inactivate contract",
    },
    PAYMENT: "Payment: ",
    TOTAL: "TOTAL",
    FORM: {
        CUSTOMER: {
            LABEL: "Customer",
            PLACEHOLDER: "Input Customer",
        },
        IS_MONTHLY: {
            LABEL: "Is Monthly",
            PLACEHOLDER: "Select option",
        },
        START_DATE: {
            LABEL: "Start Date",
            PLACEHOLDER: "Select date",
        },
        PAY_DATE: {
            LABEL: "Pay Date",
            PLACEHOLDER: "Input pay date",
        },
        NEXT_SERVICE_DEBIT_DATE: {
            LABEL: "Next Service Debit Date",
            PLACEHOLDER: "Next service debit date",
        },
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Input description",
        },
    },
    SERVICE_DETAIL: "Service Detail",
    PRICE: {
        TITLE: "Edit Price",
        PRICE: {
            LABEL: "Price",
            PLACEHOLDER: "Input price",
        },
        ACCEPT: "Accept",
        CANCEL: "Cancel",
    },
    CHARACTERISTICS: {
        LABEL: "Characteristics",
        TITLE: "Edit Characteristics",
        ACCEPT: "Accept",
        CANCEL: "Cancel",
    },
    CUSTOMER: {
        TAB_CREATE: "New Customer",
        TAB_SELECT: "Select",
        ACCEPT: "Accept",
        CANCEL: "Cancel",
        TITLE: "Add Customer",
    },
    DESCRIPTION: {
        PLACEHOLDER: "Input service description",
        LABEL: "Service Description",
        TITLE: "Edit Service Description",
        ACCEPT: "Accept",
        CANCEL: "Cancel",
    },
    LOADING: "Loading...",
    ALL: "All",
    SERVICE_DETAIL_TITLE: "Service Contract Detail",
    PAYABLE_DETAIL_TITLE: "Payable Contract Detail",
    DESTROY: {
        INACTIVATE_KEY: "inactivate",
        TITLE: "Service Contract Inactivation",
        DESCRIPTION: 'To confirm inactivation, please type "inactivate"',
        FORM: {
            CONFIRMATION: {
                LABEL: "",
                PLACEHOLDER: "inactivate",
            },
        },
    },
    INACTIVATE_CONTRACT: "Inactivate contract",
    ACTIVATE_CONTRACT: "Activate contract",
    CREATED_AT: "Created At",
    UPDATED_AT: "Last Updated",
}

const DescriptionsEsUs: CreateServiceContractDescriptions = {
    TITLE: "Crear Servicio",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Detalle de Contrato de Servicios',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Contrato de Servicios?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Servicio creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Servicio Actualizado",
    },
    MAIN_ACTION_TITLE: "Creando Categoría",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    EMPTY_STATES: {
        NO_CATEGORY_SELECTED: "Selecciona una categoría para ver los servicios",
        NO_SERVICES_FOR_CATEGORY: (categoryName: string) => `No se han encontrado servicios para la categoría ${categoryName}`,
        NO_SERVICES_IN_DETAIL: "No se han seleccionado servicios aún",
    },
    VALIDATIONS: {
        ERROR_TITLE: "Error",
        WARNING_TITLE: "Atención",
        SERVICE_ALREADY_IN_DETAIL: (serviceName: string) => `El servicio ${serviceName} ya esta agregado en el detalle`,
        SAME_TYPE_SERVICE: "Solo se pueden agregar servcios de la misma configuración Mensual",
        MISMATCH_MONTHLY_AND_SERVICE_TYPE: "El contrato esta configurado como Mensual y el servicio seleccionado no es mensual",
    },
    MONTHLY_SYMBOL: "M",
    OPTIONS: {
        ADD_PAYMENT: "Agregar pago",
        EDIT_PAYMENT: "Editar pago",
        CANCEL_INPUT: "Cancelar ingreso",
        ADD_CUSTOMER: "Aregar Cliente",
        INACTIVATE_CONTRACT: "Inactivar contrato",
    },
    PAYMENT: "Pago: ",
    TOTAL: "TOTAL",
    FORM: {
        CUSTOMER: {
            LABEL: "Cliente",
            PLACEHOLDER: "Ingrese Cliente",
        },
        IS_MONTHLY: {
            LABEL: "Es Mensual",
            PLACEHOLDER: "Seleccione una opción",
        },
        START_DATE: {
            LABEL: "Fecha Inicio",
            PLACEHOLDER: "Seleccione fecha",
        },
        PAY_DATE: {
            LABEL: "Día de pago",
            PLACEHOLDER: "Ingrese día de pago",
        },
        NEXT_SERVICE_DEBIT_DATE: {
            LABEL: "Siguiente fecha cobro",
            PLACEHOLDER: "Siguiente fecha de cobro",
        },
        DESCRIPTION: {
            LABEL: "Descripción",
            PLACEHOLDER: "Ingrese descripción",
        },
    },
    SERVICE_DETAIL: "Servicios a Contratar",
    PRICE: {
        TITLE: "Editar Precio",
        PRICE: {
            LABEL: "Precio",
            PLACEHOLDER: "Ingrese precio",
        },
        ACCEPT: "Aceptar",
        CANCEL: "Cancelar",
    },
    CHARACTERISTICS: {
        LABEL: "Características",
        TITLE: "Editar Características",
        ACCEPT: "Aceptar",
        CANCEL: "Cancelar",
    },
    CUSTOMER: {
        TAB_CREATE: "Nuevo Cliente",
        TAB_SELECT: "Seleccionar",
        ACCEPT: "Aceptar",
        CANCEL: "Cancelar",
        TITLE: "Agregar Cliente",
    },
    DESCRIPTION: {
        PLACEHOLDER: "Ingrese descripción del servicio",
        LABEL: "Descripción del Servicio",
        TITLE: "Editar Descripción del Servicio",
        ACCEPT: "Aceptar",
        CANCEL: "Cancelar",
    },
    LOADING: "Cargando...",
    ALL: "Todo",
    SERVICE_DETAIL_TITLE: "Detalle de Contrato de Servicio",
    PAYABLE_DETAIL_TITLE: "Detalle de Contrado de Pago",
    DESTROY: {
        INACTIVATE_KEY: "inactivar",
        TITLE: "Inactivación Contrato Cliente",
        DESCRIPTION: 'Para confirmar la inactivación, por favor escrite "inactivar"',
        FORM: {
            CONFIRMATION: {
                LABEL: "",
                PLACEHOLDER: "inactivar",
            }
        }
    },
    INACTIVATE_CONTRACT: "Inactivar contrato",
    ACTIVATE_CONTRACT: "Activar contrato",
    CREATED_AT: "Creado",
    UPDATED_AT: "Última actualización",
}

export const createServiceContractDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
